<template>
  <div class="visitor">
    <div class="statistics">
      <div class="statistics-item left">
        <div class="statistics-title">数据看板</div>
        <div class="statistics-body">
          <div v-for="item in boardData.left" :key="item.id" class="body-item">
            <div class="count">{{ item.num }}</div>
            <div class="label">{{ item.label }}</div>
          </div>
        </div>
      </div>
      <div class="statistics-item right">
        <div class="statistics-title">当日登记情况</div>
        <div class="statistics-body">
          <div v-for="item in boardData.right" :key="item.id" class="body-item">
            <div class="count">{{ item.num }}</div>
            <div class="label">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter">
      <el-form :inline="true">
        <el-form-item label="来访时间：">
          <el-date-picker
            v-model="value"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="dateChange"
            clearable
          />
        </el-form-item>
        <el-form-item label="访客姓名：">
          <el-input
            v-model="model.visitorName"
            placeholder="请输入"
            @change="getData"
            clearable
          />
        </el-form-item>
        <el-form-item label="访客手机：">
          <el-input
            v-model="model.visitorPhone"
            placeholder="请输入"
            @change="getData"
            clearable
          />
        </el-form-item>
        <el-form-item label="访问类型：">
          <el-select
            v-model="model.type"
            placeholder="请选择"
            @change="getData"
            clearable
          >
            <el-option
              v-for="item in options.typeList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="访问状态：">
          <el-select
            v-model="model.status"
            placeholder="请选择"
            @change="getData"
            clearable
          >
            <el-option
              v-for="item in options.statusList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="被访人姓名：">
          <el-input
            v-model="model.name"
            placeholder="请输入"
            @change="getData"
            clearable
          />
        </el-form-item>
        <el-form-item label="被访人电话：">
          <el-input
            v-model="model.phone"
            placeholder="请输入"
            @change="getData"
            clearable
          />
        </el-form-item>
        <el-form-item label="车牌号：">
          <el-input
            v-model="model.car"
            placeholder="请输入"
            @change="getData"
            clearable
          />
        </el-form-item>
        <el-form-item label="访问园区：">
          <el-select
            v-model="model.park"
            placeholder="请选择"
            @change="getData"
            clearable
          >
            <el-option
              v-for="item in options.parkList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="body">
      <div class="handle">
        <el-button type="success" icon="el-icon-search" @click="getData">
          查 询
        </el-button>
        <el-button type="info" icon="el-icon-refresh-left" @click="handleReset">
          重置
        </el-button>
        <el-button type="success" icon="el-icon-upload2" @click="handleExport">
          导 出
        </el-button>
        <el-button type="danger" icon="el-icon-delete" @click="handleDelete">
          删 除
        </el-button>
        <el-button type="danger" plain @click="handleSign"> 签 到 </el-button>
        <div>
          <span>扫码：</span>
          <el-input
            v-model="input"
            placeholder="请扫码"
            @change="changeScanning"
            clearable
            :disabled="state"
            ref="saveTagInput"
          ></el-input>
        </div>
      </div>
      <div class="table-container">
        <!-- :row-class-name="tableRowClass" -->
        <el-table
          :data="tableList"
          v-loading="tableLoading"
          @selection-change="selectionChange"
          
        >
          <el-table-column type="selection" width="55" fixed />
          <el-table-column label="访客名称" prop="visitorName" fixed />
          <el-table-column label="访客电话" width="130">
            <template slot-scope="{ row }">
              <span style="font-weight: 800">{{ row.visitorPhone }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="车牌号码"
            width="130"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">
              <span v-if="row.carInfo" style="font-weight: 800">{{
                row.carInfo
              }}</span>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column label="访问类型" prop="typeStr" />
          <el-table-column label="来访详情" prop="visitorType" />
          <el-table-column label="来访时间" prop="visitorTime" width="120" />
          <el-table-column label="访问状态">
            <template slot-scope="{ row }">
              <span
                :class="{
                  unconfirmed: row.status === 10,
                  affirm: row.status === 30
                }"
              >
                {{ row.statusStr }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="同行人员">
            <template slot-scope="{ row }">
              <span
                v-if="row.peopleNum !== 0"
                style="color: blue; cursor: pointer"
                @click="setVisiPeo(row.id)"
                >{{ row.peopleNum }}</span
              >
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column label="被访人姓名" prop="name" width="130">
            <template slot-scope="{ row }">
              <span v-if="row.name == '微信用户'">{{ row.phone }}用户</span>
              <span v-else>{{ row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="被访人部门" prop="dept" width="130" />

          <el-table-column label="被访人电话" prop="phone" width="130" />
          <el-table-column label="访问园区" prop="parkStr" />
          <el-table-column label="备注原因" prop="remarkReasons" show-overflow-tooltip/>
          <el-table-column label="来访原因" prop="visitorReasons" />
          <el-table-column
            label="签到时间"
            prop="signTime"
            width="180"
            :show-overflow-tooltip="true"
          />
          <el-table-column label="操作" width="55" fixed="right">
            <template slot-scope="{ row }">
              <i class="el-icon-edit handle-edit" @click="handleEdit(row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pager">
        <el-pagination 
          :current-page="pageData.page"
          :page-sizes="[10, 20, 40, 60, 100]"
          :page-size="pageData.pageSize"
          :total="total"
          @size-change="sizeChange"
          @current-change="currChange"
          layout="total, sizes, prev, pager, next, jumper"
        />
      </div>
    </div>
    <el-dialog title="编辑" :visible.sync="visible" width="600px">
      <el-form :model="form" ref="hook-form" label-width="100px">
        <el-form-item label="来访类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择">
            <el-option
              v-for="item in options.typeList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="访问园区" prop="park">
          <el-select v-model="form.park" placeholder="请选择">
            <el-option
              v-for="item in options.parkList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="被访人姓名" prop="phone">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="被访人电话" prop="phone">
          <el-input v-model="form.phone" />
        </el-form-item>
        <el-form-item label="被访人部门" prop="dept">
          <el-input v-model="form.dept" />
        </el-form-item>
        <el-form-item label="同行人员" prop="peopleNum" class="add-button">
          <el-input v-model="form.peopleNum" />
          <el-button type="primary" @click="PeoAdd">添加</el-button>
        </el-form-item>
        <el-form-item label="车辆类型" prop="vehicleType" v-if="form.type==8">
          <el-select v-model="form.vehicleType" placeholder="请选择车辆类型">
            <el-option label="货车" :value="1"/>
            <el-option label="面包车" :value="2"/>
            <el-option label="三轮车" :value="3"/>
          </el-select>
        </el-form-item>
        <el-form-item label="车牌号码" prop="car" class="add-button">
          <el-input v-model="form.carInfo" />
          <el-button v-if="form.type!=10" type="primary" @click="visibleCar = true">添加</el-button>
        </el-form-item>

        <el-form-item label="访客电话" prop="visitorPhone">
          <el-input v-model="form.visitorPhone" />
        </el-form-item>
        <el-form-item label="访客姓名" prop="visitorName">
          <el-input v-model="form.visitorName" />
        </el-form-item>
        <el-form-item label="访客公司" prop="visitorDept">
          <el-input v-model="form.visitorDept" />
        </el-form-item>
        <el-form-item label="来访时间" prop="visitorTime">
          <el-date-picker
            v-model="form.visitorTime"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="timeChange"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleSubmitPeoCon">取 消</el-button>
        <el-button :loading="btnLoading" type="primary" @click="handleSubmit">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="visiblePeo" width="600px" top="25vh">
      <div slot="title">
        <span class="peo-title">同行人名单</span>
      </div>
      <el-table :data="tablePeo" class="table-peo">
        <el-table-column label="序号" type="index" width="100">
        </el-table-column>
        <el-table-column label="同行人姓名" prop="name" />
        <el-table-column label="同行人手机号" prop="phone" />
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visiblePeo = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitPeo"> 确 定 </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :destroy-on-close="true"
      :visible.sync="visibleCar"
      width="600px"
    >
      <div slot="title">
        <span class="peo-title">车牌号选择</span>
      </div>
      <div>
        <car @carNum="carNum" />
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="visibleCar = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitCar"> 确 定 </el-button>
      </div> -->
    </el-dialog>

    <el-dialog
      :destroy-on-close="true"
      :visible.sync="visiblePeoAdd"
      width="600px"
      top="20vh"
    >
      <div slot="title">
        <span class="peo-title">添加同行人</span>
      </div>
      <el-form :model="form" ref="hook-form" label-width="40px">
        <el-form-item label="姓名" prop="phone">
          <el-input v-model="baseinfo.name" placeholder="请输入同行人姓名" />
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input
            placeholder="请输入11位手机号"
            v-model="baseinfo.phone"
            @blur="blur"
            type="text"
            maxlength="11"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <el-button class="addPeople" @click="addPeople" type="primary"
        >添加</el-button
      >
      <el-table :data="tablePeo" class="table-peo">
        <el-table-column label="序号" type="index" width="100">
        </el-table-column>
        <el-table-column label="同行人姓名" prop="name" />
        <el-table-column label="同行人手机号" prop="phone" />
        <el-table-column label="操作" width="100">
          <template slot-scope="{ row }">
            <span @click="emitPeople(row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visiblePeoAdd = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitPeoAdd">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <audio src="@/assets/autio/success(1).wav" class="success"></audio>
    <audio src="@/assets/autio/fail(1).wav" class="fail"></audio>
    <!-- 二维码不在本园区 -->
    <audio src="@/assets/autio/text2audio.mp3" class="audio"></audio>
  </div>
</template>

<script>
import apis from "@/apis";
import { downloadExcel } from "@/utils/tools";
import axios from "axios";
import car from "./car.vue";

export default {
  name: "visitor",
  components: {
    car
  },
  data() {
    return {
      baseinfo: {
        name: "",
        phone: "",
        id: ""
      },
      visible: false,
      visiblePeo: false,
      visibleCar: false,
      visiblePeoAdd: false,
      tableLoading: false,
      btnLoading: false,
      form: {
        visitorTime: []
      },
      pageData: {
        page: 1,
        pageSize: 10
      },
      value: "",
      options: {
        parkList: [],
        typeList: [],
        statusList: [
          { id: 10, label: "未确认" },
          { id: 20, label: "已确认" },
          { id: 30, label: "已签到" },
          { id: 90, label: "已拒绝" },
          { id: 99, label: "已取消" }
        ]
      },
      model: {},
      total: 0,
      boardData: {
        left: [],
        right: []
      },
      tableList: [],
      tablePeo: [],
      selection: [],
      input: "",
      state: false,
      flag: false,
      windowHeight: 300,
    };
  },
  watch: {
    model: function () {
      this.pageData.page = 1;
    },
    value: function () {
      this.pageData.page = 1;
    }
  },
  methods: {
  
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 470;
      });
    },
    //扫码成功
    success() {
      this.$notify({
        title: "成功",
        message: "扫码成功",
        type: "success",
        duration: 2000,
        customClass: "fontclass"
      });
    },
    //扫码失败
    error() {
      this.$notify.error({
        title: "错误",
        message: "扫码失败",
        duration: 2000,
        customClass: "fontclass"
      });
    },
    // 二维码不在本园区
    error2() {
      this.$notify.error({
        title: "错误",
        message: "该二维码不属于本园区",
        duration: 2000,
        customClass: "fontclass"
      });
    },
    // 修改表格样式
    tableRowClass(val) {
      if (val.row.backend) {
        return "backend";
      } else {
        return "";
      }
    },
    //手机号验证
    blur() {
      var reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!reg_tel.test(this.baseinfo.phone)) {
        this.$notify({
          type: "warning",
          message: "请正确输入手机格式",
          duration: 2000
        });
        this.baseinfo.phone = "";
      }
    },
    //扫码
    changeScanning() {
      var success = document.getElementsByClassName("success")[0];
      var fail = document.getElementsByClassName("fail")[0];
      var audio = document.getElementsByClassName("audio")[0];
      // 成功
      function startSu() {
        success.play();
      }
      // 失败
      function startFa() {
        fail.play();
      }
      // 不属于本园区
      function startAu() {
        audio.play();
      }
      if (
        this.input !== "" &&
        this.state === false &&
        this.input.includes("qw.nvc-lighting.com.cn") &&
        this.input.includes("signQrCode")
      ) {
        axios
          .get(
            this.input + "&" + `username=${sessionStorage.getItem("username")}`+ "&" + `check=${sessionStorage.getItem("username")}`
          )
          .then(res => {
            if (res.data.code == 200 && res.data.message != "1101") {
              // 扫码成功的语音播报
              startSu();
              this.success();
              this.input = "";
              this.getData();
            } else if (res.data.message == "1101") {
              // 不属于本园区的语音播报
              this.input = "";
              startAu();
              this.error2();
            } else {
              // 失败
              this.input = "";
              startFa();
              this.error();
            }
          })
          .catch(() => {
            // 失败
            startFa();
            this.error();
            this.input = "";
            this.getData();
          });
        this.state = true;
        setTimeout(() => {
          this.state = false;
          this.$nextTick(() => {
            // 聚焦
            this.$refs.saveTagInput.focus();
          });
        }, 2000);
      } else {
        // 二维码错误
        this.error();
        startFa();
      }
    },
    //点击同行人
    setVisiPeo(id) {
      this.visiblePeo = true;
      apis.peersQueryPeers({ id: id }).then(data => {
        this.tablePeo = data.data;
      });
    },
    //提交同行人
    handleSubmit() {
      
      let arr = [];
      let str = this.form.carInfo ? this.form.carInfo.split(",") : [];
      str &&
        str.forEach(item => {
          arr.push({ carNr: item });
        });
      this.form.cars = arr;
      if (this.form.type==10&&this.form.cars.length>1) {
        return this.$notify({
          type: "warning",
          message: "只能添加一辆车牌号码",
          duration: 2000
        });
      }
      this.btnLoading = true;
      this.form.peers = this.tablePeo;
      const time = JSON.parse(JSON.stringify(this.form.visitorTime));
      this.form.visitorTime = time[0];
      this.form.visitorTimeEnd = time[1];
      apis
        .visitorLogAddOrUpdate(this.form)
        .then(() => {
          this.visible = false;
          this.getData();
        })
        .finally(() => (this.btnLoading = false));
    },
    //确定同行人名单
    handleSubmitPeo() {
      this.visiblePeo = false;
    },
    //添加同行人
    handleSubmitPeoAdd() {
      this.visiblePeoAdd = false;
      this.form.peopleNum = this.tablePeo.length;
    },
    //取消添加同行人
    handleSubmitPeoCon() {
      this.visible = false;
      this.getData();
    },
    //添加同行人
    addPeople() {
      this.baseinfo.id = Math.ceil(Math.random() * 1000);
      const arr = JSON.parse(JSON.stringify(this.baseinfo));
      if (this.baseinfo.name !== "" && this.baseinfo.phone !== "") {
        this.tablePeo.push(arr);
      } else {
        this.$notify({
          type: "warning",
          message: "名字或手机号不能为空",
          duration: 2000
        });
      }
    },
    //编辑同行人
    emitPeople(row) {
      console.log(row);
      const index = this.tablePeo.findIndex(item => {
        return item.id === row.id;
      });
      this.tablePeo.splice(index, 1);
    },
    //添加同行人员
    PeoAdd() {
      this.visiblePeoAdd = true;
      this.baseinfo.name = "";
      this.baseinfo.phone = "";
      if (!this.flag) {
        apis.peersQueryPeers({ id: this.form.id }).then(data => {
          this.tablePeo = data.data;
          this.flag = true;
        });
      }
    },
    //车辆信息
    carNum(value) {
      if (value.length !== 0) {
        const arr = value.join(",").replace(/,/g, "");
        let oa = this.form.carInfo ? this.form.carInfo : "";
        if (oa !== "") {
          oa += "," + arr;
        } else {
          oa = arr;
        }
        this.form.carInfo = oa;
      }

      this.visibleCar = false;
    },
    // 签到
    handleSign() {
      const ids = this.selection.map(item => item.id);
      if (!ids.length) {
        return this.$message.warning("请选择需要签到的人");
      }

      this.$confirm("是否确认签到?")
        .then(async () => {
          // 对未确认状态不可进行签到，点击签到的捕获处理
          try {
            const res = await apis.signBatch({ ids });
            if (res.code !== 500) {
              this.$message.success("签到成功!");
              this.getData();
            }
          } catch (e) {
            if (e.code === 500) {
              this.$message.error(e.message);
            }
          }
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    // 导出
    handleExport() {
      apis
        .visitorLogExport({
          username: sessionStorage.getItem("username"),
          ...this.model
        })
        .then(data => {
          downloadExcel(data, "导出文件", "xls");
          this.$message.success("导出成功!");
        });
    },
    //删除访客
    handleDelete() {
      const ids = this.selection.map(item => item.id);
      if (!ids.length) {
        return this.$message.warning("请选择需要删除的访客");
      }

      this.$confirm("是否确认删除?")
        .then(() => {
          apis.visitorLogDelete({ ids }).then(() => {
            this.$message.success("删除成功!");
            this.getData();
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    //分页
    sizeChange(value) {
      this.pageData.pageSize = value;
      this.getData();
    },
    //页码
    currChange(value) {
      this.pageData.page = value;
      this.getData();
    },
    //表格选中事件
    selectionChange(v) {
      this.selection = v;
    },
    //编辑
    handleEdit(row) {
      this.form = row;
      this.form.visitorTime = [row.visitorTime, row.visitorTimeEnd];
      this.flag = false;
      this.visible = true;
    },
    //重置表单
    handleReset() {
      this.model = {};
      this.value = "";
      this.getData();
    },
    //获取园区列表
    //获取访客类型列表
    getOptions() {
      const options = this.options;
      apis.parkQueryAll({type:3}).then(({ data }) => {
        options.parkList = data;
      });

      apis.visitorTypeQueryList().then(({ data }) => {
        options.typeList = data;
      });
    },
    //时间选择
    dateChange(v) {
      const model = this.model;
      let val = ["", ""];
      if (v) {
        val = v;
      }
      model.startVisitorTime = val[0];
      model.endVisitorTime = val[1];
      this.getData();
    },
    //时间选择
    timeChange(v) {
      let val = ["", ""];
      if (v) {
        val = v;
      }
      this.form.visitorTime = val;
    },
    //数据看板
    setBoard(api, pos) {
      apis[api]({
        username: sessionStorage.getItem("username"),
        ...this.model
      }).then(({ data }) => {
        const list = [
          { label: "来访人数", id: +new Date(), num: data.visitorPeople },
          { label: "日均访客", id: +new Date() - 99, num: data.dayPeople },
          ...data.typeList
        ];
        this.boardData[pos] = list;
      });
    },
    //获取数据
    getData() {
      this.tableLoading = true;
      apis
        .logQueryByPageList({
          username: sessionStorage.getItem("username"),
          ...this.pageData,
          ...this.model
        })
        .then(({ data, total }) => {
          this.tableList = data;
          this.total = total;
          this.tableLoading = false
        })
        .finally(() => (this.tableLoading = false));
     
    }
  },
  mounted() {
     // 数据看板
     this.setBoard("logDataBoard", "left");
      // 当日登记情况
      this.setBoard("logDataBoardRight", "right");
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.getOptions();
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.visitor {
  height: calc(100vh - 77px);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0px;
    height: 1px;
    background-color: rgba(240, 240, 240, 1);
  }
}
.statistics {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  .statistics-item {
    padding: 0 30px 0 20px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #d8d8d8;

    &.left,
    &.right {
      width: 49%;
    }
  }

  .statistics-title {
    font-size: 10px;
    font-weight: 400;
    color: #000;
    line-height: 25px;
    border-bottom: 1px solid #d8d8d8;
  }

  .statistics-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 15px 5px;
  }

  .body-item {
    flex: 1;
  }

  .count {
    font-size: 12px;
    font-weight: 500;
    color: #008755;
    text-align: center;
  }
  .label {
    font-size: 8px;
    font-weight: 400;
    color: #3d3d3d;
    line-height: 15px;
    text-align: center;
  }
}
.handle {
  margin-bottom: 15px;
  display: flex;
  height: 30px;
  button {
    width: 60px;
  }
  // ::v-deep .el-input {
  //   width: 4rem;
  // }
  div {
    display: flex;
    align-items: center;
    // width: 568px;
    width: 100%;
    max-width: 568px;
    span {
      width: 40px;
      margin-left: 15px;
      color: #606266;
      font-size: 10px;
    }
  }
}
.table-container {
  margin-bottom: 10px;
}
.unconfirmed {
  color: #d02727;
}
.affirm {
  color: #018755;
}
.handle-edit {
  cursor: pointer;
}
.pager {
  display: flex;
  justify-content: flex-end;
}
.success,
.fail {
  display: none;
}

.peo-title {
  padding-left: 40%;
  font-size: 16px;
}

.addPeople {
  // position: absolute;
  // top: 45px;
  // right: 20px;
  float: right;
}

.add-button {
  ::v-deep .el-input {
    float: left;
    width: 280px;
  }
  ::v-deep .el-button {
    float: right;
  }
}
// ::v-deep .el-notification{
//   width: 450px !important;
//   height: 200px !important;
// }

.table-peo {
  ::v-deep .cell {
    font-size: 14px !important;
    line-height: 30px !important;
  }
}

::v-deep {
  .cell {
    font-size: 10px;
  }
  // .el-checkbox__inner {
  //   width: 16px;
  //   height: 16px;
  // }
  // .el-checkbox__inner::after {
  //   width: 5px;
  //   height: 9px;
  //   left: 5px;
  //   top: 1px;
  // }
}
</style>
